import { render, staticRenderFns } from "./FttbMpls.vue?vue&type=template&id=0250f15a&"
import script from "./FttbMpls.vue?vue&type=script&lang=js&"
export * from "./FttbMpls.vue?vue&type=script&lang=js&"
import style0 from "./FttbMpls.vue?vue&type=style&index=0&id=0250f15a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports